import { Carousel, VideoPlayer } from "@wbly/ui";
import React, { useMemo } from "react";
import type { FC } from "react";
import type { GalleryItem } from "@wbly/data-storefront";
import styles from "./ProductGallery.module.css";

type ProductGalleryProps = {
  children?: React.ReactNode;
  videoTitle?: string;
  cloudinaryName?: string;
  imageSize: number;
  thumbnailSize: number;
  videoSize?: number;
  gallery: GalleryItem[];
};

const { arrowLeft, arrowRight } = styles;

export const ProductGallery: FC<ProductGalleryProps> = ({
  gallery,
  imageSize,
  videoTitle,
  thumbnailSize,
  cloudinaryName,
  videoSize,
}) => {
  const slides = useMemo(
    () =>
      gallery.map((item) => {
        return (
          <Carousel.Slide
            key={item.image.src.replace(/[^a-zA-Z ]/g, "")}
            ratio="square"
          >
            {item.cldPublicId && cloudinaryName ? (
              <VideoPlayer
                videoType="carousel-video"
                cloudinaryName={cloudinaryName}
                cldPublicId={item.cldPublicId}
                videoTitle={videoTitle}
                height={videoSize}
                width={videoSize}
              />
            ) : (
              <img
                src={item.image.src}
                alt={item.image.alt}
                width={imageSize}
                height={imageSize}
              />
            )}
          </Carousel.Slide>
        );
      }),
    [gallery, cloudinaryName, imageSize, videoSize, videoTitle]
  );

  const thumbnails = useMemo(
    () =>
      gallery.map((item) => {
        return (
          <img
            src={item.image.src}
            alt={item.image.alt}
            width={thumbnailSize}
            height={thumbnailSize}
            key={`${item.image.src}-thumb`}
          />
        );
      }),
    [gallery, thumbnailSize]
  );

  return (
    <Carousel dotsNav width={imageSize} id="prod-gallery" displayAffix>
      <Carousel.Affix action="prev">
        <span className={arrowLeft}></span>
      </Carousel.Affix>
      <Carousel.Thumbnails>{thumbnails}</Carousel.Thumbnails>
      {slides}
      <Carousel.Affix position="right" action="next">
        <span className={arrowRight}></span>
      </Carousel.Affix>
    </Carousel>
  );
};
